/* Instant answers use native details; messages are submitted through Shopify's contact form. */
class MedSupport extends HTMLElement {
  connectedCallback() {
    this.widget = this.querySelector('.med-help-widget');
    this.launcher = this.querySelector('.med-help-launcher');
    if (!this.widget) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.querySelector('[data-help-close]')?.addEventListener('click', () => this.close(), options);
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !this.widget.open) return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }, options);
    document.addEventListener('click', event => {
      const trigger = event.target instanceof Element && event.target.closest('[data-med-open-help]');
      if (!trigger) return;
      event.preventDefault();
      this.returnFocus = trigger;
      this.widget.open = true;
      this.querySelector('[data-help-close]')?.focus();
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.widget.open || event.composedPath().includes(this)) return;
      this.widget.open = false;
    }, options);
    this.widget.addEventListener('toggle', () => {
      this.launcher.setAttribute('aria-expanded', String(this.widget.open));
    }, options);
    this.launcher.setAttribute('aria-expanded', String(this.widget.open));
  }
  close() {
    this.widget.open = false;
    const target = this.returnFocus?.isConnected ? this.returnFocus : this.launcher;
    target?.focus();
    this.returnFocus = null;
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('med-support')) customElements.define('med-support', MedSupport);
